/*
 * @Date: 2024-08-28 17:56:12
 * @LastEditors: Leo
 * @LastEditTime: 2024-08-28 17:56:12
 * @description: globaljs - 全局功能组件
 */
import './index.less'
import DetailsDisclosure from '../../components/details-disclosure'
import QuantityInput from '../../components/quantity-input'
import DetailsModal from '../../components/details-modal'
import {CartDrawer, CartDrawerItems, CartRemoveButton, CartItems} from "../../components/cart-drawer"
import {pushMessage, pushSuccessMessage, pushErrorMessage } from "../../components/jky-toast/init-toast"
import jkyVideo from '../../components/jky-video'
import jkyForm from "../../components/jky-form"
import ZModle from "../../components/z-modal"
import fixedIcons from '@plugins/fixed-icons'

customElements.define('details-disclosure', DetailsDisclosure)
customElements.define('details-modal', DetailsModal)

// 购物车相关组件
customElements.define('cart-remove-button', CartRemoveButton)
customElements.define('cart-items', CartItems)
customElements.define('cart-drawer', CartDrawer)
customElements.define('cart-drawer-items', CartDrawerItems)
customElements.define('quantity-input', QuantityInput)

window.pushMessage = pushMessage;
window.pushSuccessMessage = pushSuccessMessage;
window.pushErrorMessage = pushErrorMessage;
window.ZModle = ZModle
jkyVideo()
jkyForm()

// 插件懒加载
document.addEventListener("DOMContentLoaded", function () {
  setTimeout(() => {
    if('requestIdleCallback' in window) {
      requestIdleCallback(() => {
        // 全局悬浮提示组件
        fixedIcons()          // 全局悬浮 icons
      }, {timeout: 2000})
    } else {
      fixedIcons()
    }

    // 通知
    import(/* webpackChunkName: "notification" */ '../../plugins/notification/index').then((module) => {
      const app = module.default
      app();
      console.log("jky app [notification]:loaded")
      return true
    }).catch(() => {
      console.log("jky app [notification]:fail")
      return false
    })

    // 心愿单
    if(window?.pageInfo?.settings?.open_wishlist && window?.pageInfo?.template?.startsWith("product")) {
      import(/* webpackChunkName: "wishlist-new-4-0-3" */ '../../plugins/wishlist/index').then((module) => {
        const app = module.default
        app();
        console.log("jky app [wishlist]:loaded")
        return true
      }).catch(() => {
        console.log("jky app [wishlist]:fail")
        return false
      })
    }
  }, 300)
})
